import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  Layer,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import auth from "./Security/Auth";
import { SingleSelect } from "react-select-material-ui";

class FirstTimeUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 1,
      TimeZoneData: undefined,
      RegionData: undefined,
      JobRoleData: undefined,
      JobLevelData: undefined,
      CountryData: undefined,
      LocationData: undefined,
      finished: false,
      stepIndex: 0,
      showSubmitLoader: false,
      submitDisabled: false,
      emailAddress: auth.getUserEmail(),
      usrimg: undefined,
      companyValue: undefined,
      countryvalue: "India",
      locationID: 100,
      regionValue: undefined,
      timezoneValue: undefined,
      jobRoleValue: "Introductory",
      locationValue: undefined,
      jobLevelValue: undefined,
      learnerValue: undefined,
      nextClicked: false,
      locationID: undefined,
      submitClicked: false,
      RegionSelect: [],
      UserInfo: auth.getUserInfo(),
    };

    //this.handleChange = this.handleChange.bind(this);
    this.loadTimeZoneData = this.loadTimeZoneData.bind(this);
    this.loadRegionData = this.loadRegionData.bind(this);
    this.loadLocationData = this.loadLocationData.bind(this);
    //this.loadJobRoleData =this.loadJobRoleData.bind(this);
    this.loadJobLevelData = this.loadJobLevelData.bind(this);
    this.loadCountryData = this.loadCountryData.bind(this);
    this.handleCompany = this.handleCompany.bind(this);
    this.handleRegion = this.handleRegion.bind(this);
    this.handleCountry = this.handleCountry.bind(this);
    this.handleTimeZone = this.handleTimeZone.bind(this);
    this.handleJob = this.handleJob.bind(this);
    this.handleLearner = this.handleLearner.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkForLearnerId = this.checkForLearnerId.bind(this);
    this.handleLevel = this.handleLevel.bind(this);
  }

  componentDidMount() {
    console.log("** User Info as Props Passed below**");
    console.log(this.props.Uinfo);
    this.loadTimeZoneData();
    this.loadRegionData();
    // this.loadJobRoleData();
    this.loadJobLevelData();
    this.loadCountryData();
    this.loadLocationData();
    console.log("** LocationData Captured From API");
    console.log(this.state.LocationData);

    if (this.state.UserInfo) {
      this.setState({
        companyValue: this.state.UserInfo.Company
          ? this.state.UserInfo.Company
          : undefined,
        countryvalue: this.state.UserInfo.UserLocation
          ? this.state.UserInfo.UserLocation.Country
          : undefined, //this.state.UserInfo.UserLocation.Country
        jobvalue: this.state.UserInfo.UserExpertise
          ? this.state.UserInfo.UserExpertise.ExpertLevelName
          : undefined,
        usrimg: this.state.UserInfo.UsrImgData,
        regionValue: this.state.UserInfo.UserLocation
          ? this.state.UserInfo.UserLocation.Region
          : undefined,
        timezoneValue: this.state.UserInfo.TimeZone
          ? this.state.UserInfo.TimeZone.Timezone_ID
          : undefined,
        //jobRoleValue: (this.state.UserInfo.UserJob ? this.state.UserInfo.UserJob.JobID: undefined),
        jobRoleValue: this.state.UserInfo.Job,
        locationValue: this.state.UserInfo.UserLocation
          ? this.state.UserInfo.UserLocation.Country
          : undefined,
        jobLevelValue: this.state.UserInfo.UserExpertise
          ? this.state.UserInfo.UserExpertise.ExpertLevelID
          : undefined,
        learnerValue: this.state.UserInfo.LearnerID,
        locationID: this.state.UserInfo.UserLocation
          ? this.state.UserInfo.UserLocation.LocationID
          : undefined,
      });
      if (!this.state.UserInfo.LearnerID) {
        this.checkForLearnerId();
      }
    }
  }

  checkForLearnerId() {
    var endpoint = "/Account/FindLearnerID";
    let token = auth.getToken();
    var postData = {
      UserType: this.state.UserInfo.UserTypeID,
      UserEmail: this.state.UserInfo.EmailAddress,
    };

    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("learner ID data from API:", data);
      if (data) {
        console.log("Learner ID data: ");
        this.setState({ learnerValue: data[0] });
      }
    });
  }

  loadTimeZoneData() {
    var endpoint = "/Metadata/GetTimezones";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("TimeZone data from API:", data);
      this.setState({
        TimeZoneData: data,
      });
    });
  }

  loadRegionData() {
    var endpoint = "/Metadata/GetRegions";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Region data from API:", data);
      this.setState({
        RegionData: data,
      });
    });
  }

  loadLocationData() {
    var endpoint = "/Metadata/GetLocations";
    let token = auth.getToken();
    console.log(auth.getToken());
    let locData = [];
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Locations from API:", data);
      locData.push(data[0]);
      var AllCountriesList = [];
      data.forEach(function (item, index) {
        console.log(item);
        AllCountriesList = AllCountriesList.concat(item.LstCountryVM);
      });

      var sort_by = function (field, reverse, primer) {
        var key = primer
          ? function (x) {
              return primer(x[field]);
            }
          : function (x) {
              return x[field];
            };

        reverse = !reverse ? 1 : -1;

        return function (a, b) {
          return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
        };
      };
      console.log(AllCountriesList);
      AllCountriesList.sort(
        sort_by("Country", false, function (a) {
          return a.toUpperCase();
        })
      );
      console.log(AllCountriesList);
      this.setState({
        LocationData: data,
        RegionSelect: locData,
        CountriesList: AllCountriesList,
      });
    });
  }

  /* loadJobRoleData() {
    var endpoint = '/Metadata/GetJobs';
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then(data => {
        console.log('Job Role data from API:', data);
        this.setState({
            JobRoleData: data
        });
    });
}*/

  loadJobLevelData() {
    var endpoint = "/Metadata/GetExpertLevels";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Job Level data from API:", data);
      this.setState({
        JobLevelData: data,
      });
    });
  }

  loadCountryData() {
    var endpoint = "/Metadata/GetCountries";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Country data from API:", data);
      this.setState({
        CountryData: data,
      });
    });
  }

  handleCompany(event, value) {
    this.setState({ companyValue: value });
  }
  handleRegion(event, index, value) {
    let regionData = [];
    regionData.push(this.state.LocationData[index]);
    console.log(regionData);
    this.setState({
      regionValue: value,
      RegionSelect: regionData,
    });
  }

  handleCountry(value) {
    let locationID;
    console.log("**HandleCountry Clicked with selection below");
    console.log(value);
    console.log("**AllListOf Countries below");
    console.log(this.state.CountriesList);

    this.state.CountriesList.map((country) => {
      console.log(country);
      if (country.Country == value) {
        locationID = country.LocationID;
        console.log("Value Matched");
        console.log(country);
        console.log(country.LocationID);
        console.log(locationID);
        this.setState({ countryvalue: value, locationID: locationID });
        /*         this.setState({countryvalue : value});
        this.setState({locationID : locationID}); */
      }
    });
  }

  handleTimeZone(value) {
    if (this.state.TimeZoneData) {
      this.state.TimeZoneData.map((tz) => {
        if (tz.Timezone_Name === value) {
          this.setState({ timezoneValue: tz.Timezone_ID });
        }
      });
    }
  }
  handleJob(value) {
    console.log("** Job text provided as ", value);
    this.setState({ jobRoleValue: value });
  }

  handleLocation(event, index, value) {
    this.setState({ locationValue: value });
  }
  handleLevel(value) {
    let ExpertiseID;
    console.log("**Handle Job or Expertise Clicked with selection below");
    console.log(value);
    console.log("**AllListOf Expertises below");
    if (this.state.JobLevelData) {
      console.log(this.state.JobLevelData);
    }
    if (this.state.JobLevelData) {
      this.state.JobLevelData.map((job) => {
        console.log(job);
        if (job.ExpertLevelName == value) {
          ExpertiseID = job.ExpertLevelID;
          console.log("Value Matched");
          console.log(job);
          console.log(job.ExpertLevelID);
          console.log(ExpertiseID);
          this.setState({ jobLevelValue: ExpertiseID });
        }
      });
    }
  }
  handleLearner(event, value) {
    this.setState({ learnerValue: value });
  }
  handleSubmit = () => {
    //alert("Submitted");
    const {
      jobRoleValue,
      locationID,
      jobLevelValue,
      companyValue,
      timezoneValue,
      learnerValue,
    } = this.state;
    //if (this.state.jobRoleValue) {
    //console.log("**Job Role Value is ", this.state.jobRoleValue);
    this.setState({ showSubmitLoader: true, submitDisabled: true });
    var profileData = {
      EmailAddress: this.state.emailAddress,
      Company: companyValue,
      TimeZone: { Timezone_ID: timezoneValue },
      LearnerID: learnerValue,
      Job: "App Arch", // this.state.jobRoleValue,
      /* "Job": {
              "JobID": jobRoleValue
          },*/
      UserLocation: {
        LocationID: locationID,
      },
      UserExpertise: {
        ExpertLevelID: jobLevelValue,
      },
    };
    var endpoint = "/Account/UpdateUserProfile";
    let token = auth.getToken();
    var postData = profileData;
    console.log("Profile request data for user Update :", profileData);
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("Profile result data from API:", data);
      if (data) {
        console.log("UpdateMessage: ");
        console.log(data.UpdateMessage);

        auth.updateUserInfo(data);
        this.props.history.push("/home");
        //this.props.router.replace("/home");
      }
    });
    //}
    /* else {
      this.setState({ submitClicked: true });
    } */
  };

  render() {
    var TimezoneList = new Array();
    //var RegionList= "";
    //var JobRoleList= "";
    var JobLevelList = new Array();
    var CountryList;
    var Avatarimg = "";
    let countList = new Array();
    //var LocationList="";
    if (this.state.TimeZoneData) {
      //var TimezList = new Array();
      this.state.TimeZoneData.map((tz) => {
        TimezoneList.push(tz.Timezone_Name);
      });
    }
    /* if (this.state.LocationData) {
       //var CountList = new Array();
      this.state.CountriesList.map((cntry) => {
        CountryList.push(cntry.Country);
      });
    } */

    console.log("**Timezonelist**");
    console.log(TimezoneList);

    console.log("**Imp Returned Data for location on change**");
    console.log(this.state.locationvalue);
    console.log(this.state.locationID);

    console.log("* Imp Data Returned for Job Role  on change *");
    console.log(this.state.jobRoleValue);

    if (this.state.usrimg) {
      Avatarimg = this.state.usrimg;
    }

    /*     if (this.state.LocationData) {
      CountryList = this.state.CountriesList.map(function (item, index) {
        return <MenuItem value={item.LocationID}>{item.Country}</MenuItem>;
      });
    } */
    console.log("**CountryList Before **");
    console.log(countList);

    console.log("**Location Data **");
    console.log(this.state.LocationDate);

    if (this.state.CountriesList) {
      this.state.CountriesList.map((country) => {
        countList.push(country.Country);
      });
      console.log("**CountryList After**");
      console.log(countList);
    }

    if (this.state.JobLevelData) {
      // JobLevelList = this.state.JobLevelData;
      this.state.JobLevelData.map((job) => {
        JobLevelList.push(job.ExpertLevelName);
      });
      console.log("**Expertise Level List**");
      console.log(JobLevelList);
    }

    var isSubmitDisabled = true;
    var submitDisabledForLoading = this.state.submitDisabled
      ? this.state.submitDisabled
      : false;

    if (this.state.countryvalue && this.state.timezoneValue) {
      isSubmitDisabled = false;
    }

    return (
      <Layer animate modal full="vertical" position="center">
        <Heading level="1" size="xxsmall" margin="none">
          Mandatory information required !
        </Heading>
        <Box
          align="start"
          justify="between"
          background={{ color: "background-front" }}
          pad="medium"
          height="small"
          gap="small"
          hoverIndicator={{ dark: true }}
          direction="row"
        >
          {/*  <Avatar
            align="center"
            flex={false}
            justify="center"
            overflow="hidden"
            round="full"
            src={Avatarimg}
          /> */}
          <Grid
            columns={[{ size: "xxsmall", count: 1 }, "medium"]}
            rows={["flex"]}
            gap="small"
          >
            {/*             <Text>Job Role</Text>
            <TextInput
              onChange={this.handleJob}
              value={this.state.jobRoleValue}
            /> */}
            <Avatar
              align="center"
              flex={false}
              justify="center"
              overflow="hidden"
              round="full"
              src={Avatarimg}
            />
            <Text>Company</Text>
            <TextInput
              onChange={this.handleCompany}
              value={this.state.companyValue}
            />
            {/* <Text>Learner ID</Text>
            <TextInput
              value={this.state.learnerValue}
              onChange={this.handleLearner}
            /> */}
            <Text>Country</Text>
            <SingleSelect
              value={this.state.countryvalue}
              placeholder="Select your Country"
              options={countList}
              onChange={this.handleCountry}
            />

            {/* <Text>Newletter subscription</Text>
            <Select options={["yes", "no"]} dropHeight="small" /> */}
            <Text>Expertise Level</Text>
            <SingleSelect
              value={this.state.jobvalue}
              placeholder="Select your Expertise Level"
              options={JobLevelList}
              onChange={this.handleLevel}
            />
            <Text>TimeZone</Text>
            <SingleSelect
              value={this.state.timezoneValue}
              placeholder="Select your Timezone"
              options={TimezoneList}
              onChange={this.handleTimeZone}
            />
            {/* <Select options={["TimezoneList", "Myzonelist"]} /> */}
            <Box align="center" justify="center" gap="large" pad="large">
              <Button
                label={
                  this.state.showSubmitLoader ? (
                    <Box
                      direction="row"
                      gap="small"
                      justify="center"
                      align="center"
                    >
                      <Spinner size="small" color="brand" />{" "}
                      <Text>Updating..</Text>
                    </Box>
                  ) : (
                    "Submit"
                  )
                }
                size="large"
                secondary={false}
                disabled={isSubmitDisabled || submitDisabledForLoading}
                primary
                gap="large"
                onClick={this.handleSubmit}
              />
            </Box>
          </Grid>
        </Box>
      </Layer>
    );
  }
}

/* FirstTimeUser.propTypes = {
  Uinfo: React.PropTypes.object.isRequired,
}; */

export default withRouter(FirstTimeUser);
